var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tkBanner"},[_c('tk-link',{attrs:{"href":_vm.href,"target":_vm.target}},[_c('tk-image',{staticClass:"tkBanner_image",attrs:{"image-path":_vm.imagePath,"alt":_vm.alt}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }